"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateSystemVariables = exports.ITemplateVariable = void 0;
class ITemplateVariable {
}
exports.ITemplateVariable = ITemplateVariable;
exports.TemplateSystemVariables = ['subscriber', 'step', 'branding'];
